import { COMPANY_LEGAL_COPY } from '../../../../../v2/shared/company-legal-copy';
import { AfterViewChecked, ChangeDetectorRef, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { tap } from 'rxjs/operators';
import { PHONE_MASK } from '../../../../../common/helpers';
import { ToastService } from '../../../../../main/services';
import { createSupplierForm } from '../../../../forms';
import { Supplier } from '../../../../models';
import { SuppliersService } from '../../../../services';

@Component({
    selector: 'jft-create-supplier-form',
    templateUrl: './create-supplier-form.component.html',
    styleUrls: ['./create-supplier-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateSupplierFormComponent implements OnInit, AfterViewChecked  {
    public header: String;
    public formType: String = 'add';
    public form: UntypedFormGroup;
    /** D-549: "Company Legal Name", its tip and error. */
    public readonly legal = COMPANY_LEGAL_COPY;
    public contact: UntypedFormGroup;
    public phoneMask = PHONE_MASK;
    public availableTags: any[] = [];
    public selectedTags: any[] = [];
    public tags: any[] = [];
    public loading = false;
    public isSupplierActive: boolean = false;

    constructor(
        private toast: ToastService,
        private supplierService: SuppliersService,
        private activeModal: NgbActiveModal,
        private supplier: Supplier,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {
    }

    public ngAfterViewChecked(): void {
        this.changeDetectorRef.detectChanges();
    }

    public ngOnInit() {
        this.form = createSupplierForm(this.supplier);
        this.contact = this.form.get('contact') as UntypedFormGroup;
        this.header = this.formType == 'add' ? 'Add Supplier Contact' : 'Edit Supplier Contact';
        this.initAvailableTags();
        this.selectedTags = this.supplier.contact ? this.supplier.contact.tags : [];

        // Check if supplier is active (email verified)
        this.isSupplierActive = this.supplier.contact?.emailVerified === true;

        // If editing an active supplier, disable all fields except supplier_alias and tags
        if (this.isSupplierActive && this.formType === 'edit') {
            this.form.get('name').disable();
            this.contact.get('first_name').disable();
            this.contact.get('last_name').disable();
            this.contact.get('email').disable();
            this.contact.get('phone').disable();
            // Keep supplier_alias and tags enabled - they can always be edited
        }

    }

    private initAvailableTags() {
        this.availableTags.forEach((c, i) => {
            this.tags.push({id: c.id, name: c.name});
        });
    }

    public tagChange(tags){
        this.form.get('contact.tags').patchValue(tags, {emitEvent: false});
    }

    public addTagPromise(name) {
        return {id: 0, name: name};
    }

    public getFormGroupErrorClasses(control: AbstractControl): {} {
        return {'is-invalid': control.invalid && control.touched};
    }

    public showErrorBlock(control: AbstractControl): boolean {
        return control.errors && (control.dirty || control.touched);
    }

    public close() {
        this.activeModal.dismiss();
    }

    public create() {
        if (!this.form.valid) {
            return;
        }

        this.form.disable();

        // Use getRawValue() to include disabled fields (important for active suppliers where only alias is enabled)
        const formData = this.form.getRawValue();

        if (this.formType == 'add') {
            this.supplierService.create(formData)
            .pipe(tap(() => {
                this.form.enable();
            }))
            .subscribe((data) => {
                this.activeModal.close({success: true});
                this.toast.success(`Supplier ${data.name} added`);
            }, (e) => {
                this.toast.error(e);
            });
        } else {
            this.supplierService.update(formData)
            .pipe(tap(() => {
                this.form.enable();
            }))
            .subscribe((data) => {
                this.activeModal.close({success: true});
                this.toast.success(`Supplier ${data.name} has been changed`);
            }, (e) => {
                this.toast.error(e);
            });
        }

    }

}
